// src/App.js
import React from 'react';
import { Helmet } from 'react-helmet';
import { ToastContainer } from 'react-toastify';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

import Logo from './assest/images/37a39cb7092d94d7297953ad09f2dee5.png';

// Auth Pages
import DoctorLogin from './pages/Authentication/DoctorLogin';
import PatientLogin from './pages/Authentication/PatientLogin';
import Register from './pages/Authentication/Register';
import Signin from './pages/Authentication/Signin';
import StaffLogin from './pages/Authentication/StaffLogin';
import AdminLogin from './pages/Authentication/AdminLogin';

// App Pages
import Bookingform from './pages/Bookings/Bookingform';
import Doctors from './pages/Doctors/Doctors';
import DoctorShedule from './pages/Doctors/DoctorShedule';
import Main from './pages/Index';
import Patients from './pages/Patients';
import Pharmacy from './pages/Pharmacy';
import ProductDetails from './pages/ProductDetails';
import Staff from './pages/Staff/Staff';
import ScheduleTime from './pages/Doctors/ScheduleTime';
import Success from './pages/Bookings/Success';
import Details from './pages/Doctors/Details';
import Admin from './pages/admin/Admin';
import DoctorsPage from './pages/Doctors';

// Utils
import ProtectedRoute from './ProtectedRoute';
import Layout from './components/Layout';

function App() {
  return (
    <div className="App">
      <ToastContainer autoClose={3000} />
      <Helmet>
        <title>Amarasingha Medicare</title>
        <link rel="icon" href={Logo} type="image/png" />
      </Helmet>

      <BrowserRouter>
        <Routes>
          {/* Public Routes wrapped in Layout */}
          <Route path="/" element={<Layout><Main /></Layout>} />
          <Route path="/signin" element={<Layout><Signin /></Layout>} />
          <Route path="/register" element={<Layout><Register /></Layout>} />
          <Route path="/DoctorLogin" element={<Layout><DoctorLogin /></Layout>} />
          <Route path="/StaffLogin" element={<Layout><StaffLogin /></Layout>} />
          <Route path="/patientLogin" element={<Layout><PatientLogin /></Layout>} />
          <Route path="/AdminLogin" element={<Layout><AdminLogin /></Layout>} />

          {/* Pages */}
          <Route path="/patients" element={<Layout><Patients /></Layout>} />
          <Route path="/bookingform" element={<Layout><Bookingform /></Layout>} />
          <Route path="/success" element={<Layout><Success /></Layout>} />
          <Route path="/doctors" element={<Layout><Doctors /></Layout>} />
          <Route path="/doctorShedule" element={<Layout><DoctorShedule /></Layout>} />
          <Route path="/scheduletime" element={<Layout><ScheduleTime /></Layout>} />
          <Route path="/details" element={<Layout><Details /></Layout>} />
          <Route path="/staff" element={<Layout><Staff /></Layout>} />
          <Route path="/pharmacy" element={<Layout><Pharmacy /></Layout>} />
          <Route path="/product/:id" element={<Layout><ProductDetails /></Layout>} />
          <Route path="/doctorspage" element={<Layout><DoctorsPage /></Layout>} />

          {/* Protected Admin Route */}
          <Route path="/admin" element={
            <ProtectedRoute>
              <Layout>
                <Admin />
              </Layout>
            </ProtectedRoute>
          } />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
